export default "__VITE_ASSET__DLXuyjxm__"